import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';

import colors from 'constants/colors';
import IMAGES from 'shared/constants/images';
import Button from 'shared/modules/common/components/atoms/Button';
import Dialog from 'shared/modules/common/components/atoms/Dialog';

type Props = {
  open: boolean;
  onCloseButtonPress: () => void;
};

const TimeOutErrorModal = (props: Props) => {
  return (
    <Dialog
      title=""
      open={props.open}
      onClose={props.onCloseButtonPress}
      style={style.root}
      showCloseButton={false}
    >
      <View style={style.topContainer}>
        <Image source={IMAGES.exclaimTriangle} style={style.headerImage} />

        <Text style={style.title}>エラーが発生しました</Text>
        <Text style={style.text}>
          {`しばらく時間をおいてから\nもう一度お試しください。`}
        </Text>
      </View>
      <View style={style.bottomContainer}>
        <Button
          title="Ok"
          onPress={props.onCloseButtonPress}
          style={style.button}
          id="timeout-error-close-button"
        />
      </View>
    </Dialog>
  );
};

const style = StyleSheet.create({
  root: {
    width: '100%',
    maxWidth: 624,
  },
  text: {
    fontSize: 16,
    color: colors.greyDark,
    marginBottom: 24,
    alignSelf: 'center',
    fontWeight: '300',
  },
  button: {
    marginBottom: 16,
    maxWidth: 296,
    alignSelf: 'center',
    justifyContent: 'flex-end',
  },
  title: {
    fontSize: 20,
    color: colors.greyDark,
    marginBottom: 24,
    alignSelf: 'center',
    fontWeight: '600',
  },
  headerImage: {
    width: 184,
    height: 184,
    alignSelf: 'center',
  },
  topContainer: {
    flex: 1,
  },
  bottomContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
});

export default TimeOutErrorModal;
